export const DEFAULT_PROGRAM_NAME = 'Committed Club';
